<template>
    <div>
        <el-form  :model="formData" ref="formData" label-width="120px" size="mini" :inline="true">

            <el-form-item  prop="vc_name" label="商品名称" required>
                <el-input :disabled="canEdit" class="changeinput" size="mini" v-model="formData.vc_name"  ></el-input>
            </el-form-item>
            <el-form-item  prop="vc_name_nick" label="商品别名" >
                <el-input :disabled="canEdit" class="changeinput" size="mini" v-model="formData.vc_name_nick"  ></el-input>
            </el-form-item>

            <el-form-item  prop="vc_ename" label="英文名称" >
                <el-input :disabled="canEdit" class="changeinput" size="mini" v-model="formData.vc_ename"  ></el-input>
            </el-form-item>
            <el-form-item  prop="vc_hy" label="品种行业" >
                <el-input :disabled="canEdit" class="changeinput" size="mini" v-model="formData.vc_hy"  ></el-input>
            </el-form-item>
            <el-form-item label="计价单位:" prop="vc_priceunit" class="w50" required>
                <el-select v-model="formData.vc_priceunit" style="width: 100%" @change="changejjdw" filterable clearable size="mini" :disabled="canEdit||data.i_id!=0">
                    <el-option
                            v-for="item in jjdwList"
                            :key="item.i_baseunit_id"
                            :label="item.vc_baseunit_name"
                            :value="item.i_baseunit_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="计量单位:" prop="vc_unit" class="w50" required>
                <el-select v-model="formData.vc_unit"  size="mini" @change="changeUnit" filterable  style="width: 100%"  :disabled="canEdit||data.i_id!=0">
                    <el-option
                            v-for="item in dictList"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item  prop="vc_hgszh" label="海关税则号" >
                <el-input :disabled="canEdit" class="changeinput" size="mini" v-model="formData.vc_hgszh"  ></el-input>
            </el-form-item>
            <el-form-item  prop="i_distype" label="激励分类" required>
                <el-select :disabled="canEdit" style="width: 100%"  class="marr4" v-model="formData.i_distype" size="mini" filterable placeholder="请选择公司">
                    <el-option v-for="item in jlflList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item  prop="f_zx_n" label="大陆内销激励" >
                <el-input-number class="w100" :controls="false" v-model.number="formData.f_zx_n" size="mini" :disabled="canEdit" :precision="4" ></el-input-number>
            </el-form-item>
            <el-form-item  prop="f_zx_w" label="大陆外销激励" >
                <el-input-number class="w100" :controls="false" v-model.number="formData.f_zx_w" size="mini" :disabled="canEdit" :precision="4" ></el-input-number>
            </el-form-item>
            <el-form-item  prop="f_zc_n" label="外销支持激励" >
                <el-input-number class="w100" :controls="false" v-model.number="formData.f_zc_n" size="mini" :disabled="canEdit" :precision="4" ></el-input-number>
            </el-form-item>
            <el-form-item  prop="f_wx_n" label="海外内销激励" >
                <el-input-number class="w100" :controls="false" v-model.number="formData.f_wx_n" size="mini" :disabled="canEdit" :precision="4" ></el-input-number>
            </el-form-item>
            <el-form-item  prop="f_fx_w" label="海外分销激励" >
                <el-input-number class="w100" :controls="false" v-model.number="formData.f_fx_w" size="mini" :disabled="canEdit" :precision="4" ></el-input-number>
            </el-form-item>
            <el-form-item  prop="f_wx_w" label="海外外销激励" >
                <el-input-number class="w100" :controls="false" v-model.number="formData.f_wx_w" size="mini" :disabled="canEdit" :precision="4" ></el-input-number>
            </el-form-item>
            <el-form-item  prop="f_cg_n" label="采购激励-国内" >
                <el-input-number class="w100" :controls="false" v-model.number="formData.f_cg_n" size="mini" :disabled="canEdit" :precision="4" ></el-input-number>
<!--                <el-input :disabled="canEdit" class="changeinput" size="mini" v-model="formData.f_cg_n"  ></el-input>-->
            </el-form-item>
            <el-form-item  prop="f_cg_w" label="采购激励-国外" >
                <el-input-number class="w100" :controls="false" v-model.number="formData.f_cg_w" size="mini" :disabled="canEdit" :precision="4" ></el-input-number>
<!--                <el-input :disabled="canEdit" class="changeinput" size="mini" v-model="formData.f_cg_w"  ></el-input>-->
            </el-form-item>
            <el-form-item  prop="i_flag" label="产品属性" required>
                <el-select disabled   class="marr4" v-model="formData.i_flag" size="mini"  filterable placeholder="请选择产品属性">
                    <el-option v-for="item in sxList" :key="item.i_flag" :label="item.vc_flag" :value="item.i_flag">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="类型:" class="w50"  prop="i_isprocess" required>
                <el-select   class="marr4" v-model="formData.i_isprocess" size="mini" :disabled="canEdit"  placeholder="请选择类型">
                    <el-option v-for="item in jgList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属板块:" prop="i_sector_id" class="w50" required>
                <el-select v-model="formData.i_sector_id"  size="mini" @change="changeSector" :remote="true"
                           :remote-method="bksearch"   style="width: 100%" >
                    <el-option
                            v-for="item in bkList"
                            :key="item.i_id"
                            :label="item.vc_name"
                            :value="item.i_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item  prop="i_syncyy_type" label="用友同步方式" required>
<!--                <el-radio-group disabled v-model="formData.i_syncyy_type" >-->
<!--                    <el-radio :label='1'>按产品</el-radio>-->
<!--                    <el-radio :label='2'>按规格</el-radio>-->
<!--                </el-radio-group>-->
                <span v-if="formData.i_syncyy_type==1">按产品</span>
                <span v-if="formData.i_syncyy_type==2">按规格</span>
            </el-form-item>
            <el-form-item label="用友code:" class="w50"  prop="vc_code_yongyou" v-if="formData.i_syncyy_type==1">
                <span style="margin-right: 3px">{{formData.vc_code_yongyou}}</span>
                <el-button v-if="formData.i_id!=0" type="text" @click="tosync('用友')">同步</el-button>
            </el-form-item>
            <el-form-item label="南北code:" class="w50"  prop="vc_code_nanbei">
                <span style="margin-right: 3px">{{formData.vc_code_nanbei}}</span>
                <el-button v-if="formData.i_id!=0" type="text" @click="tosync('南北')">同步</el-button>
            </el-form-item>
            <el-form-item  prop="i_type_sel" label="财务成本核算" required>
                <el-radio-group :disabled="canEdit||data.i_id!=0" v-model="formData.i_type_sel" >
                    <el-radio :label='0'>按产品</el-radio>
                    <el-radio :label='1'>按批次</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item  prop="i_ispno" label="ERP统计粒度" required>
                <el-radio-group :disabled="canEdit||data.i_id!=0" v-model="formData.i_ispno" >
                    <el-radio :label='2'>按规格</el-radio>
                    <el-radio :label='3'>按批次</el-radio>
                </el-radio-group>
            </el-form-item>
<!--            <el-form-item  prop="i_pzid_kcjs_sel" label="ERP库存核算" required>-->
<!--                <el-radio-group :disabled="canEdit" v-model="formData.i_pzid_kcjs_sel" >-->
<!--                    <el-radio :label='0'>按产品</el-radio>-->
<!--                    <el-radio :label='1'>按规格</el-radio>-->
<!--                </el-radio-group>-->
<!--            </el-form-item>-->
            <el-form-item label="是否计件:" class="w50"  prop="isjian" required>
                <el-radio-group :disabled="canEdit||data.i_id!=0" v-model="formData.isjian" >
                    <el-radio :label='0'>否</el-radio>
                    <el-radio :label='1'>是</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="是否启用:"class="w50"  prop="isuse" required>
                <el-radio-group :disabled="canEdit" v-model="formData.isuse" >
                    <el-radio :label='0'>否</el-radio>
                    <el-radio :label='1'>是</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="散水/非散水:" class="w50"  prop="i_isbulk" required>
                <el-radio-group  :disabled="canEdit||data.i_id!=0" v-model="formData.i_isbulk" >
                    <el-radio :label='1'>散水</el-radio>
                    <el-radio :label='0'>非散水</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-table border ref="sgtable1" size="mini" v-if="formData.i_syncyy_type==1&&distributedList.length>0" :data="distributedList" :height="tableHeight-100"
                      :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true">
                <!--            <el-table-column  align="center"   type="selection" width="50px" ></el-table-column>-->
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column  prop="vc_gsname"  label="下发公司"  show-overflow-tooltip>
                    <!--                <template slot-scope="scope">-->
                    <!--                    <el-select class="marr4 w100"  v-model="scope.row.i_gsid" size="mini"  filterable >-->
                    <!--                    <el-option v-for="item in gsList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">-->
                    <!--                    </el-option>-->
                    <!--                </el-select>-->
                    <!--                </template>-->
                </el-table-column>
                <el-table-column  prop="vc_pz_attr"  label="属性"  show-overflow-tooltip>
                    <!--                <template slot-scope="scope">-->
                    <!--                    <el-select  class="marr4 w100"  v-model="scope.row.i_pz_attr" size="mini" clearable filterable >-->
                    <!--                        <el-option v-for="item in flagList" :key="item.i_flag" :label="item.vc_flag" :value="item.i_flag">-->
                    <!--                        </el-option>-->
                    <!--                    </el-select>-->
                    <!--                </template>-->
                </el-table-column>
                <!--            <el-table-column label="操作" width="40" align="center">-->
                <!--                <template slot="header" slot-scope="scope" >-->
                <!--                    <el-button  icon="el-icon-plus" @click="addRow"   size="mini"  type="text" ></el-button>-->
                <!--                    &lt;!&ndash;                            <el-button class="addbtn" @click="popShow" slot="reference" :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>&ndash;&gt;-->
                <!--                </template>-->
                <!--                <template slot-scope="scope">-->
                <!--                    <el-button  icon="el-icon-minus" type="text" v-if="scope.row.i_id==0" @click="deletepz(scope.row,scope.$index)"  size="mini"></el-button>-->
                <!--                    &lt;!&ndash;                    <el-button  type="text"  @click="addSg(scope.row,scope.$index)"  size="mini" >编辑</el-button>&ndash;&gt;-->
                <!--                </template>-->
                <!--            </el-table-column>-->
            </el-table>
            <div class="flex">
                <el-form-item class="form-title" prop="vc_lruname" label="录入人" >
                    <span>{{formData.vc_lruname}}</span>
                </el-form-item>
                <el-form-item class="form-title" prop="dt_createtime" label="录入日期" >
                    <span>{{formData.dt_createtime}}</span>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <template >
                <el-button type="primary" @click="saveForm('formData')" :disabled="disabled" :class="baseerp+'btn'" size="mini" >保存</el-button>
            </template>

            <el-button @click="cancel" size="mini">取 消</el-button>

        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";

    export default {
        name: "ChanPin",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                tableHeight:0,
                baseerp:'',
                formData:{
                    vc_name:'',
                    vc_name_nick:'',
                    vc_ename:'',
                    vc_unit:'',
                    i_distype:0,
                    vc_hy:'',
                    vc_hgszh:'',
                    vc_lruname:'',
                    dt_createtime:'',
                    f_zx_n:'',
                    f_zx_w:'',
                    f_wx_n:'',
                    f_fx_w:'',
                    f_wx_w:'',
                    f_zc_n:'',
                    f_cg_n:'',
                    f_cg_w:'',
                    i_type_sel:0,
                    i_flag:0,
                    i_ispno:3,
                    i_pzid_kcjs_sel:1,isuse:1,
                    i_isprocess:0,
                    vc_priceunit: "",
                    i_syncyy_type:1,
                    isjian: 0,
                    i_isbulk:0,i_sector_id:'',
                    vc_code_yongyou:'',
                    vc_code_nanbei:'',
                    i_meteringunit_id:0,
                    i_priceunit_id:0,
                    i_unitgroup_id:0,
                },
                distributedList:[],
                disabled:false,
                canEdit:false,
                jlflList:[{i_id:0,vc_name:'默认类'},{i_id:1,vc_name:'聚醚类'}],
                dictList:[],
                jjdwList:[],
                sxList:[],
                jgList:[{i_id:0,vc_name:'默认'},{i_id:1,vc_name:'受托加工'},{i_id:2,vc_name:'研发'},{i_id:3,vc_name:'委外加工'}],
                bkList:[],
            }
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
            data:{
                handler(){
                    if(this.data){
                        if(this.data.i_id==0){
                            this.formData.i_id=this.data.i_id;
                            this.formData.i_mdid=this.data.i_mdid;
                            this.formData.i_flag=this.data.i_flag;
                            // this.formData.vc_name=this.data.vc_name;
                            this.formData.i_pzid_kcjs_sel=this.data.i_pzid_kcjs_sel;
                            this.formData.isuse=this.data.isuse?this.data.isuse:1;
                            this.formData.i_type_sel=this.data.i_type_sel;
                            this.formData.i_ispno=this.data.i_ispno?this.data.i_ispno:3;
                            this.formData.vc_unit=this.data.vc_unit;
                            let now=this.$DateTime.now();
                            this.formData.dt_createtime=now.toFormat('yyyy-MM-dd');
                            this.formData.vc_lruname=sessionStorage.getItem("lruname");
                            this.formData.i_lruid=sessionStorage.getItem("userid");
                        }else{
                            this.getProductDetail()
                            // this.formData=JSON.parse(JSON.stringify(this.data))
                        }
                    }
                },
                deep:true,
                immediate:true
            }
        },
        activated(){
            this.onResize();
        },
        mounted() {

            // console.log(this.formData,'--------------------------')
            this.findClassificationAttributes();
            this.getDictList('jjdw','');
            this.getSectorList();
            this.baseerp=baseerp;
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-145;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            tosync(text){
                this.$confirm('是否同步到'+text+'系统','提示',{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消',
                    type:"warning"
                }).then(()=>{
                    // console.log(this.formData,"this.formData")
                    this.updatesystem(text);
                }).catch(()=>{
                    this.$message.info('取消操作')
                })
            },
            async updatesystem(text){
                let param={
                    i_id:this.formData.i_id,
                };
                let res={};
                if(text=='用友'){
                    res=await API.saveYYProductSpecification(param);
                }
                if(text=='南北'){
                    res=await API.saveSNProductCategory(param);
                }
                if ( res.code == 1 ){
                    this.getProductDetail()
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            changeUnit(e){
                //console.log('e',e);
                this.formData.i_meteringunit_id=e;
                let choo = this.dictList.filter(item => {
                    return item.i_id == e
                });
                if(choo.length>0){
                    this.formData.vc_unit = choo[0].vc_name;
                }else{
                    this.formData.vc_unit = ''
                }

            },
            changejjdw(e){
                console.log('e',e);
                this.formData.i_priceunit_id = e;
                let choo = this.jjdwList.filter(item => {
                    return item.i_baseunit_id == e
                });
                if(choo.length>0){
                    this.formData.vc_priceunit = choo[0].vc_baseunit_name;
                    this.formData.i_unitgroup_id = choo[0].i_id;
                }else{
                    this.formData.vc_priceunit = ''
                    this.formData.i_unitgroup_id = 0;
                }
                this.dictList=[];
                this.formData.i_meteringunit_id=0;
                this.formData.vc_unit='';
                this.getDictList('jldw',this.formData.i_unitgroup_id);

            },
            cancel(){
                this.$emit('close')
            },
            // save(formName){
            //     this.$refs[formName].validate((valid)=>{
            //         if(valid){
            //             this.addCompany()
            //         }else{
            //             return false
            //         }
            //     })
            // },
            saveForm(formName){
                // if(this.formData.i_khid==''||this.formData.i_khid==undefined||this.formData.i_gsid==''||(this.formData.i_isbankcharges===0&&this.formData.vc_bank_account=='')||this.formData.f_pay==0||this.formData.f_rate==0){
                //     this.$message.warning('请填写必需项')
                // }else{
                    this.$refs[formName].validate((valid)=>{
                        if(valid){
                            this.addOrupdateProduct()
                        }else{
                            return false
                        }
                    })
                // if(this.formData.vc_name==''||this.formData.vc_name==undefined){
                //     this.$message.error('请输入商品名称');
                //     return
                // }
                // if(this.formData.vc_priceunit==''||this.formData.vc_priceunit==undefined){
                //     this.$message.error('请输入计价单位');
                //     return
                // }
                // if(this.formData.vc_unit==''||this.formData.vc_unit==undefined){
                //     this.$message.error('请输入计价单位');
                //     return
                // }
                //
                //  this.addOrupdateProduct()
                //
                //     this.disabled=true
                // }

            },
            async addOrupdateProduct(){
                this.disabled=true
                this.formData.operate=this.formData.i_id?1:0;
                if(this.formData.i_id==0){
                    this.formData.i_pid=this.data.i_pid;
                    this.formData.vc_app=this.baseerp;
                    this.formData.isyw=0
                }else{
                    // this.formData.i_pid=this.data.i_typepid;
                //
                }
                let now=this.$DateTime.now();
                this.formData.dt_createtime=now.toFormat('yyyy-MM-dd');
                this.formData.vc_lruname=sessionStorage.getItem("lruname");
                this.formData.i_lruid=sessionStorage.getItem("userid");
                let param=this.formData;
                let res=await API.addOrupdateProduct(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message);
                    this.$emit('close','save');
                    this.disabled=false
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false

                }
            },
            //单位接口(计量单位)
            async getDictList(type,val){
                let param={
                    vc_type:'unit',
                    vc_unit_parent:null,
                    i_unitgroup_id:val,
                };
                let param2={
                    i_isuse:1,
                    vc_search:'',
                    pageSize:99,
                    currentPage:1
                };
                let res={};
                if(type=='jldw'){
                    res=await API.getDictList(param);
                }
                if(type=='jjdw'){
                    res=await API.getUnitGroupList(param2);
                }
                if (res.code==1){
                    //console.log(res,"getDict");
                    if(type=='jjdw'){
                        this.jjdwList=res.data.list;
                    }else if(type=='jldw'){
                        this.dictList=res.data;
                        let o=this.dictList.findIndex(d=>d.vc_name==this.formData.vc_unit);
                        if(o==-1){
                            this.$set(this.formData,"vc_unit",'')
                        }
                    }else{
                        this.dictList=res.data;
                        this.jjdwList=res.data;
                    }
                    //console.log(this.dictList,"this.dictList")
                }
            },
            async findClassificationAttributes(){
                let param={

                };
                let res=await API.findClassificationAttributes(param);
                if ( res.code == 1 ){
                    this.sxList=res.data
                    let obj=this.sxList.find(sx=>sx.i_flag==this.data.i_flag);
                    // this.formData.i_syncyy_type=obj.i_syncyy_type
                    this.$set(this.formData,'i_syncyy_type',obj.i_syncyy_type)
                    console.log(obj)
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false

                }
            },
            async getProductDetail(){
                let param={
                    i_id:this.data.i_id,
                    i_typepid:this.data.i_typepid
                };
                let res=await API.getProductDetail(param);
                if ( res.code == 1 ){
                    this.formData=res.data
                    this.distributedList=res.data.distributedList
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            bksearch(e){
                this.bk_seaech=e
                this.getSectorList()
            },
            changeSector(){
                if(this.formData.i_sector_id){
                    this.formData.vc_sector_name=this.bkList.find(g=>g.i_id==this.formData.i_sector_id).vc_name
                }else{
                    this.formData.vc_sector_name=''
                }
            },
            async getSectorList(){
                let param={
                    "vc_search":this.bk_seaech,
                    "i_isuse":1,
                    "pageSize":50,
                    "currentPage":1
                };
                let res=await API.getSectorList(param);
                if ( res.code == 1 ){
                    this.bkList=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .flex{
        display: flex;

    }

    .w100{
        width: 100%;
    }
    div .el-form-item{
        width: 350px;

    }
    .el-radio{
        margin-right: 12px;
    }
    /deep/{
        .el-form-item__content{
            width: 230px;
        }
        /*.upload-input[data-v-a4d5ba82]{*/
        /*    right:160px;*/
        /*    bottom: 10px;*/
        /*}*/
    }
</style>